import { makeStyles } from '@material-ui/core';

export const contasPagarStyles = makeStyles({
  situacaoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  badge: {
    color: '#ffffff',
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 12,
    fontWeight: 600,
    borderRadius: '0px !important',
    width: '60px',
    textAlign: 'center',
  },
  badgeAberta: {
    backgroundColor: '#3286a8',
  },
  badgeBaixada: {
    backgroundColor: '#2dc44d',
  },
  badgeExcluida: {
    backgroundColor: '#b53838',
  },
  badgePagoParcialmente: {
    backgroundColor: '#e65c17',
  }
});
